import _axios from "../../../httpService"
import ReactDOM from "react-dom";
import React, {Fragment, useContext, useEffect, useState} from "react";
import Modal, {ModalBody, ModalHeader} from "../../Modal";
import ModalFooter from "../../Modal/ModalFooter";
import Loader from "../../Loader";
import {prefixUrl} from "../../../utils/utilsData";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import utilsFunction from "../../../utils/utilsFunction";
import numericFunction from "../../../utils/NumericFunction";
import {toast} from "react-toastify";
import {SetPrintDataContext} from "../../../Pages/index"
import {useNavigate} from "react-router-dom";

function ModalOverlay(props) {

  const {selectedRow, whichKey, type, isOpen, modalCallback, entityName} = props;
  let typeToSend = 'account'
  let whichKeyToSend = 'primaryKey';
  if (type) {
    typeToSend = type
  }
  if (whichKey) {
    whichKeyToSend = whichKey;
  }

  const primaryKey = selectedRow.getData()['primaryKey'];
  const sendDateByContext = useContext(SetPrintDataContext);
  const navigateTo = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState("");
  const [data, setData] = useState([]);
  const [sendData, setSendData] = objectDataHolder({
    filter: {
      filterType: "all", // all  date  tearMonth
      startDate: "", endDate: "", year: "", month: "", monthYearToShow: "",
    }, forms: []
  });

  useEffect(() => {
    if (!primaryKey) {
      console.log(" primaryKey یه مقدار معتبر باشه که توی ستون های جدول نیست. اینجا باید مقدار");
      alert("primaryKey یافت نشد.")
      return null
    }

    setIsLoading(true);
    _axios.get(prefixUrl() + "/accountingPrint/?request=modalOptions&type=" + typeToSend + "&id=" + primaryKey + "&entity=" + props.entityName + "&selectType=" + props.selectType)
      .then(res => {
        const data = res.data;
        console.log(res)
        if (data.status) {
          setData(data.data)

          // به صورت پیشفرض تیک ها باشه
          // اول من میریزمشون توی آرایه و توی فرم هم دیفالت چک رو میزنم
          // توی فرم بر اساس آرایه چک نمیشه
          // ولی وقتی تیک رو برداره از آرایه حذف میشه
          const forms = [];
          // تیک دستی
          forms.push('manual')
          data.data.forEach(v => forms.push(v.value))
          setSendData({forms: forms})
        } else {

          setHasError(<div className={"alert alert-danger text-center"}>
            مشکلی در دریافت داده وجود دارد.
          </div>)
        }
        setIsLoading(false);

      })

  }, [])

  const [show, setShow] = useState(false);

  const radioButtonShowDateHandler = (e) => {
    const {name, value} = e.target;
    if (value === "today") {
      setShow(false);
    }
    if (value === "inDate") {
      setShow(true);
    }
  }

  const checkBoxHandler = e => {
    const forms = [...sendData.forms]
    if (e.target.checked) {

      !forms.find(v => v === e.target.value) && forms.push(e.target.value)
    } else {

      forms.find(v => v === e.target.value) && forms.splice(forms.indexOf(e.target.value), 1)
    }

    console.log(forms)
    setSendData({forms: forms})


  }

  const submitModal = () => {

    //کنترل موارد ورودی
    if (sendData.forms.length === 0) {
      toast.error("انتخاب حداقل یک مورد الزامی است")
      return
    }
    if ((sendData.filter.filterType === "yearMonth" && sendData.filter.year === '') || (sendData.filter.filterType === "yearMonth" && sendData.filter.month === '')) {
      toast.error("لطفا سال و ماه را انتخاب کنید.")
      return
    }
    if ((sendData.filter.filterType === "inDate" && sendData.filter.startDate === '') || (sendData.filter.filterType === "inDate" && sendData.filter.endDate === '')) {
      toast.error("لطفا تاریخ شروع و پایان را وارد کنید.")
      return
    }

    _axios.get(prefixUrl() + "/accountingPrint/?request=printData&type=" + typeToSend + "&id=" + primaryKey + "&options=" + JSON.stringify(sendData) + '&entity=' + props.entityName + "&selectType=" + props.selectType)
      .then(res => {
        const data = res.data;

        data.data.type = "printType7";
        sendDateByContext(data.data);
        navigateTo("/factorprint");
      })
  }

  return <>
    <Modal
      isOpen={isOpen}
      modalCallback={modalCallback}
    >
      <ModalHeader title={"صورتحساب حسابداری"}/>
      <ModalBody>
        {hasError && <>{hasError}</>}
        <div>
          {isLoading ? <><Loader/></> : <div className={"d-flex flex-wrap justify-content-center"}>
            <div className={"col-3 d-flex   py-2 "}>
              <input
                onChange={e => checkBoxHandler(e)}

                className="form-check-input  ml-radio0"
                type="checkbox"
                name="data"
                value={"manual"}
                id={"manual"}
                defaultChecked={true}
              />
              <label className="form-check-label px-2 d-block" htmlFor={"manual"}>سندهای دستی</label>
            </div>
            {data.map((row, index = 0) => (<Fragment key={index}>
              <div className={"col-3 d-flex   py-2 "}>
                <input
                  onChange={e => checkBoxHandler(e)}
                  className="form-check-input  ml-radio0"
                  type="checkbox"
                  name="data"
                  value={row.value}
                  id={row.value}
                  defaultChecked={true}

                />
                <label className="form-check-label px-2 d-block" htmlFor={row.value}>{row.label}</label>
              </div>
            </Fragment>))}
          </div>}
          <div className={" py-2"}>
            <div onChange={radioButtonShowDateHandler}
                 className="col-12 justify-content-around py-2 ">
              <div className="d-flex">
                <div> مشاهده به صورت:</div>
                <div className="d-flex mx-2">
                  <input
                    className="form-check-input"
                    type={"radio"}
                    name="date"
                    value={"today"}
                    id={"today"}
                    defaultChecked={true}
                    onClick={() => setSendData({
                      filter: {
                        filterType: "all", // all  date  tearMonth
                        startDate: "", endDate: "", year: "", month: "", monthYearToShow: "",
                      }
                    })}

                  />
                  <label className="form-check-label  d-block" htmlFor={"today"}>همه</label>
                </div>
                <div className="d-flex">
                  <input
                    className="form-check-input  ml-radio0"
                    type={"radio"}
                    name="date"
                    value={"inDate"}
                    id={"inDate"}
                    onClick={() => setSendData({
                      filter: {
                        filterType: "inDate", // all  date  tearMonth
                        startDate: "", endDate: "", year: "", month: "", monthYearToShow: "",
                      }
                    })}
                  />
                  <label className="form-check-label px-2 d-block" htmlFor={"inDate"}>
                    در بازه تاریخ
                  </label>

                </div>
                <div className="d-flex">
                  <input
                    className="form-check-input  ml-radio0"
                    type={"radio"}
                    name="date"
                    value={"yearMonth"}
                    id={"yearMonth"}
                    onClick={() => setSendData({
                      filter: {
                        filterType: "yearMonth", // all  date  tearMonth
                        startDate: "", endDate: "", year: "", month: "", monthYearToShow: "",
                      }
                    })}
                  />
                  <label className="form-check-label mx-2 d-block" htmlFor={"yearMonth"}>سال و ماه</label>

                </div>
              </div>
              <div className="d-flex">
              </div>
              {(sendData.filter.filterType === "all" || sendData.filter.filterType === undefined) ? <></> : sendData.filter.filterType === "inDate" ? <>
                <div
                  className={"d-flex d-block"}
                  style={{width: '25%'}}
                >
                  <div className="d-flex0">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="از تاریخ"
                        name={"fromDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        value={sendData.filter.startDate}
                        onChange={date => {
                          setSendData({
                            filter: {
                              ...sendData.filter, startDate: numericFunction.p2e(date.toLocaleString()),
                            }
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex0">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="تا تاریخ"
                        name={"toDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"

                        value={sendData.filter.endDate}
                        onChange={date => {
                          setSendData({
                            filter: {
                              ...sendData.filter, endDate: numericFunction.p2e(date.toLocaleString()),
                            }
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </> : sendData.filter.filterType === "yearMonth" ? <>
                <div
                  className={"d-flex d-block"}
                  style={{width: '25%'}}
                >
                  <div className="d-flex0">
                    <div className="form-control">
                      {/*in this section when i add  onlyMonthPicker    it never changed So i set Value to this and Its Worked */}
                      <DatePicker
                        onlyMonthPicker
                        calendar={persian}
                        className="form-control"
                        placeholder="انتخاب سال و ماه"
                        name={"yearMonth000"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        value={"1800/12/12"}
                        onChange={date => {


                          const monthYearToShow = numericFunction.p2e(date.toLocaleString())

                          const yearMonth: string[] = date.toLocaleString().split("/");
                          const month = utilsFunction.giveMonthByNumber(numericFunction.p2e(yearMonth[0]))
                          const year = numericFunction.p2e(yearMonth[1])
                          setSendData({filter: {...sendData.filter, year: year, month: month, monthYearToShow}})
                        }}

                      />
                    </div>
                  </div>

                </div>
              </> : <></>}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          onClick={submitModal}
          className={"btnCustom btnSubmit mx-1"}>
          تایید
        </button>
      </ModalFooter>
    </Modal>

  </>;
}

const OpenModalSelectBillItemToPrint = (props) => {

  return (<React.Fragment>
    {ReactDOM.createPortal(<ModalOverlay {...props}/>, document.getElementById('overlay-root'))}
  </React.Fragment>);
};

export default OpenModalSelectBillItemToPrint